import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'

const ITEM_PAGE_BUY_BUTTON_METRIC_NAME = 'frontend_item_buy_button'

export const incrementItemPageBuyButtonShowCounter = (available: boolean) => {
  clientSideMetrics.counter(ITEM_PAGE_BUY_BUTTON_METRIC_NAME, { available }).increment()
}
